// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1wJA2","col":"styles_col__3Pvv0"};